import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { Segment } from 'semantic-ui-react'

import { useAuthStore } from '../stores/authStore.js'
import { clearLocalTokens } from '../features/auth/lib/authSession.js'
import { getHomeUrl } from '../features/auth/lib/homeUrl.js'
import { KindeLogin } from '../features/auth/components/KindeLogin/KindeLogin.jsx'

export function LoginPage() {
  const [searchParams] = useSearchParams()
  const isReset = ['1', 'true'].includes(searchParams.get('reset'))
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  // Support escape hatch (/login?reset=1): wipe every local session artifact,
  // then revoke the Kinde SSO session and land back here clean. Visiting the
  // link is an explicit user action — the same sanctioned class as clicking
  // Logout — so revoking the shared session is allowed on this path.
  useEffect(() => {
    if (!isReset) return
    useAuthStore.getState().clearUser()
    clearLocalTokens()
    const redirect = encodeURIComponent(`${window.location.origin}/login`)
    window.location.href = `${process.env.REACT_APP_KINDE_DOMAIN}/logout?redirect=${redirect}`
  }, [isReset])

  if (isReset) {
    return <Segment style={{ height: '100vh' }} loading />
  }

  if (isAuthenticated) {
    return <Navigate to={getHomeUrl()} replace />
  }

  return <KindeLogin />
}
